import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const FORBIDDEN_BRANDS = [
  'AC',
  'Aston Martin',
  'Bizzarrini',
  'Ferrari',
  'ISO',
  'Lamborghini',
  'Maserati',
  'Porsche',
  'Rolls Royce',
] as const;

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Construeix una regex de "paraula sencera" per una marca.
 * - Fa match amb límits de paraula.
 * - Si la marca té espai o guió, permet separadors: espais o guions (incloent hyphen no-breaking).
 */
function brandToWholeWordRegex(brand: string): RegExp {
  const upper = brand.toUpperCase();

  // Convertim espais i guions del nom a un separador flexible:
  // "ASTON MARTIN" => "ASTON[\\s\\-\\u2011]+MARTIN"
  // "ROLLS-ROYCE" => "ROLLS[\\s\\-\\u2011]+ROYCE"
  const tokens = upper.split(/[\s\-]+/).map(escapeRegExp);
  const flexible = tokens.join('[\\s\\-\\u2011]+');

  // Límits de paraula: evitem "ISO" dins "ISOLATION" o "AC" dins "RACING"
  // \b funciona bé per lletres/números/underscore.
  return new RegExp(`\\b${flexible}\\b`, 'i');
}

export function vehicleBrandValidator(): ValidatorFn {
  const patterns = FORBIDDEN_BRANDS.map(brandToWholeWordRegex);

  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw == null || raw === '') return null;

    const value = raw.toString();

    const idx = patterns.findIndex((rx) => rx.test(value));
    if (idx === -1) return null;

    return { forbiddenBrand: FORBIDDEN_BRANDS[idx] };
  };
}
